<template>
  <div class="footer-region">
    <div class="w">
      <div class="footer-top clearfix">
        <div class="footer-left">
          <a href="/cn" title="依图科技"
            ><img src="https://www.yitutech.com/sites/all/themes/yitu/images/logo.svg" alt=""
          /></a>
        </div>
        <div class="footer-right">
          <div id="block-block-3" class="block block-block footer-block">
            <h2>商务合作</h2>

            <ul>
              <li>
                <a href="mailto: marketing@yitu-inc.com"
                  >marketing@yitu-inc.com</a
                >
              </li>
            </ul>
          </div>
          <div id="block-block-4" class="block block-block footer-block">
            <h2>媒体采访</h2>

            <ul>
              <li>
                <a href="mailto: media@yitu-inc.com">media@yitu-inc.com</a>
              </li>
            </ul>
          </div>
          <div id="block-block-6" class="block block-block footer-block">
            <h2>关于我们</h2>

            <ul>
              <li><a href="/cn/about-us?hash=team">创始团队</a></li>
              <li><a href="/cn/about-us?hash=history">大事记</a></li>
            </ul>
          </div>
          <div id="block-block-7" class="block block-block footer-block">
            <h2>加入我们</h2>

            <ul>
              <li><a href="/cn/career?mode=social">社招</a></li>
              <li><a href="/cn/career?mode=campus">校招</a></li>
              <li>
                <a href="/cn/career?mode=campus&amp;intern=true">实习热招</a>
              </li>
            </ul>
          </div>
          <div id="block-block-8" class="block block-block footer-block">
            <h2>关注我们</h2>

            <ul>
              <li>
                <a class="gzh" href="javascript:;"
                  >公众号<span
                    ><img
                      src="https://www.yitutech.com/sites/all/themes/yitu/images/yitu_gongzhonghao.jpg" /></span
                ></a>
              </li>
              <li>
                <a
                  class="gzh"
                  href="https://m.weibo.cn/u/5453041495"
                  target="_blank"
                  >微博<span
                    ><img src="	https://www.yitutech.com/sites/all/themes/yitu/images/weibo.jpg" /></span
                ></a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div id="block-block-2" class="block block-block">
        <div class="address-list">
          <p>
            上海：上海市徐汇区云锦路701号西岸国际人工智能中心21层<br />
            总机：021 - 52559588
          </p>

          <p>北京：北京市朝阳区北三环东路8号静安中心25层</p>

          <p>杭州：杭州市西湖区紫霞街176号4号楼7层</p>
        </div>
      </div>

      <div class="footer">
        <div id="block-block-1" class="block block-block">
          <p>
            <a href="/cn/privacy-policy">隐私政策</a> |
            <a href="/cn/legal">法律声明</a> |
            <a href="/cn/content/人权声明">人权声明</a>&nbsp; 版权所有 ©
            上海依图网络科技有限公司 2012-2021
            <a href="https://beian.miit.gov.cn/#/Integrated/index"
              >沪ICP备14000593号-2</a
            >&nbsp; 沪公网安备<a
              href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502003345"
              >31010502003345</a
            >号&nbsp; 增值电信经营许可证：沪B2-20190650&nbsp;&nbsp;
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tecFooter',
  props: {
    msg: String,
  },
};
</script>

<style scoped>
.footer-region {
  background: #0e0e2a;
  width: 100%;
  position: relative;
}

.footer {
  font-size: 12px;
  line-height: 200%;
  color: #fff;
  opacity: 0.6;
  padding: 15px 0;
}

.footer p {
  font-size: 12px;
  line-height: 150%;
  padding: 28px 0;
}

.footer a {
  color: #fff;
  opacity: 0.6;
  transition: all 0.5s;
}

.footer a:hover {
  opacity: 1;
}

.footer-top {
  padding: 30px 0;
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.footer-left {
  width: 258px;
  padding-top: 30px;
  float: left;
}

.footer-left img {
  width: 258px;
  height: 42px;
}

.footer-right {
  width: calc(100% - 318px);
  float: right;
  display: flex;
  justify-content: space-between;
}

.footer-block h2 {
  font-family: PingFangSC-Medium;
  font-size: 12px;
  line-height: 150%;
  color: #ffffff;
  margin-bottom: 25px;
}

.footer-block li a {
  font-size: 12px;
  color: #fff;
  opacity: 0.6;
  line-height: 28px;
  transition: all 0.5s;
}

.footer-block li a:hover {
  opacity: 1;
}

.footer-block li a.gzh {
  position: relative;
}

.footer-block li a.gzh span {
  display: block;
  position: absolute;
  bottom: 0;
  right: 100%;
  width: 160px;
  height: 160px;
  display: none;
}

.footer-block li a.gzh span img {
  width: 100%;
  height: 100%;
}

.footer-block li a.gzh:hover span {
  display: block;
}

.w {
  width: 100%;
  max-width: 1240px;
  padding: 0 20px;
  margin: 0 auto;
  position: relative;
}

.footer-top {
  padding: 30px 0;
  color: #fff;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.clearfix:after {
  content: '';
  display: block;
  width: 100%;
  height: 0;
  overflow: hidden;
  clear: both;
}

.address-list {
  padding: 15px 0;
  display: flex;
  justify-content: space-between;
}

.address-list p {
  color: #fff;
  opacity: 0.6;
  font-size: 12px;
  line-height: 200%;
}

</style>
